import classNames from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FiChevronLeft, FiChevronRight, FiX } from 'react-icons/fi';
import { IoMdImage } from 'react-icons/io';
import { Link } from 'react-router-dom';
import { Swipeable } from 'react-swipeable';
import styles from '../PageProductGallery/styles.scss';

class PageProductGallery extends Component {
    static propTypes = {
        backUrl: PropTypes.string.isRequired,
        photos: PropTypes.array.isRequired,
        prevProductLink: PropTypes.any,
        nextProductLink: PropTypes.any,
        unmount: PropTypes.func.isRequired,
    };

    state = {
        activePhotoIndex: 0,
    };

    handleSwipes = (e) => {
        const { photos } = this.props;
        const { activePhotoIndex } = this.state;
        let toIndex;

        if (e.dir === 'Left') {
            toIndex = photos[activePhotoIndex + 1] ? activePhotoIndex + 1 : 0;
        } else if (e.dir === 'Right') {
            toIndex = photos[activePhotoIndex - 1] ? activePhotoIndex - 1 : 0;
        }

        this.moveSliderTo(toIndex)();
    };

    moveSliderTo = (index) => () => {
        this.setState({
            activePhotoIndex: index,
        });
    };

    render() {
        const { backUrl, photos, prevProductLink, nextProductLink, unmount } = this.props;
        const { activePhotoIndex } = this.state;

        return (
            <Swipeable onSwiped={this.handleSwipes} className={styles.photoContainer}>
                <div className={styles.photo}>
                    <div className={styles.photoContent}>
                        {photos && photos.length > 0 && (
                            <div className={styles.productImgContainer}>
                                <ul
                                    className={styles.imagesList}
                                    style={{ transform: `translateX(-${activePhotoIndex * 16.666666}%)` }}
                                >
                                    {photos.map((url, index) => (
                                        <li key={index}>
                                            <img src={url} alt={url} />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        {(!photos || photos.length === 0) && (
                            <div className={styles.photoPlaceholder}>
                                <IoMdImage size="40%" color="#fff" />
                            </div>
                        )}
                    </div>
                    <div className={styles.controls}>
                        {nextProductLink && (
                            <Link to={nextProductLink}>
                                <div className={styles.paginationControl}>
                                    <FiChevronLeft size={16} />
                                </div>
                            </Link>
                        )}
                        {prevProductLink && (
                            <Link to={prevProductLink} className={styles.nextLink}>
                                <div className={styles.paginationControl}>
                                    <FiChevronRight size={16} />
                                </div>
                            </Link>
                        )}
                        {photos && photos.length > 1 && (
                            <div className={styles.dotsContainer}>
                                {photos.map((filename, index) => (
                                    <div
                                        key={filename + index}
                                        className={classNames(styles.dot, {
                                            [styles.active]: activePhotoIndex === index,
                                        })}
                                        onClick={this.moveSliderTo(index)}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                    <Link onClick={(e) => unmount(e, backUrl)} to={backUrl} className={styles.closeBtn}>
                        <div>
                            <FiX size={16} />
                        </div>
                    </Link>
                </div>
            </Swipeable>
        );
    }
}

export default PageProductGallery;
